import { useState } from "react";
import { api, errText } from "../lib/api";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import { ShieldAlert, X } from "lucide-react";
import { toast } from "sonner";

const REASONS = [
  ["impersonation", "Pretending to be someone else"],
  ["brand", "Misusing a brand / trademark"],
  ["fake", "Fake or misleading identity"],
  ["other", "Other"],
];

// Report a user or crew for impersonation / brand disputes.
export function ReportImpersonationModal({ open, onClose, targetType, targetId, targetLabel }) {
  const [reason, setReason] = useState("impersonation");
  const [details, setDetails] = useState("");
  const [busy, setBusy] = useState(false);
  if (!open) return null;
  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/reports/impersonation", { target_type: targetType, target_id: targetId, reason, details });
      toast.success("Report sent to moderators. Thank you.");
      onClose();
    } catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-[60] bg-black/70 flex items-center justify-center p-4" onClick={onClose} data-testid="report-impersonation-modal">
      <div className="surface rounded-2xl p-6 w-full max-w-sm relative" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-4 right-4 text-muted-foreground hover:text-white"><X size={18} /></button>
        <div className="flex items-center gap-2 mb-1"><ShieldAlert size={18} className="text-rose-400" /><h3 className="font-display font-bold text-lg">Report {targetLabel}</h3></div>
        <p className="text-xs text-muted-foreground mb-4">Help keep VirtuStars authentic. Reports go to our moderation team.</p>
        <div className="space-y-1.5 mb-3">
          {REASONS.map(([val, label]) => (
            <button key={val} onClick={() => setReason(val)} className={`w-full text-left text-sm px-3 py-2 rounded-lg border transition ${reason === val ? "border-rose-400 bg-rose-500/10 text-white" : "border-white/10 surface-2 text-muted-foreground"}`} data-testid={`report-reason-${val}`}>{label}</button>
          ))}
        </div>
        <Textarea value={details} onChange={(e) => setDetails(e.target.value)} placeholder="Add any details (optional)" className="surface-2 border-white/10 mb-3" data-testid="report-details" />
        <Button onClick={submit} disabled={busy} className="btn-blue rounded-xl w-full" data-testid="report-submit">{busy ? "Sending…" : "Submit report"}</Button>
      </div>
    </div>
  );
}
